import { EmployeeSchedule } from '../employee/schedule/schedule.types';
import { useSaveSchedule } from './useSaveSchedule';

export const useSaveEmployeeSchedule = (employeeId: string, startDate: Date, endDate: Date) => {
  const { save: saveSchedule, fetching } = useSaveSchedule(startDate, endDate);

  const save = (schedule: EmployeeSchedule) => saveSchedule(employeeId, schedule);

  return { save, fetching };
};
